// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

=========================================================
* Paper Dashboard React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
.tim-row {
  margin-bottom: 20px;
}

.tim-white-buttons {
  background-color: #777777;
}

.typography-line {
  padding-left: 25%;
  margin-bottom: 35px;
  position: relative;
  display: block;
  width: 100%;
}

.typography-line span {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  position: absolute;
  width: 260px;
  text-transform: none;
}

.tim-row {
  padding-top: 60px;
}

.tim-row h3 {
  margin-top: 0;
}

.offline-doc .page-header {
  display: flex;
  align-items: center;
}

.offline-doc .footer {
  position: absolute;
  width: 100%;
  background: transparent;
  bottom: 0;
  color: #fff;
  z-index: 1;
}

@media all and (min-width: 992px) {
  .sidebar .nav>li.active-pro {
    position: absolute;
    width: 100%;
    bottom: 10px;
  }
}

.card.card-upgrade .card-category {
  max-width: 530px;
  margin: 0 auto;
}

/* Nucleo Style */

.demo-iconshtml {
  font-size: 62.5%;
}

.demo-icons body {
  font-size: 1.6rem;
  font-family: sans-serif;
  color: #333333;
  background: white;
}

.demo-icons a {
  color: #608cee;
  text-decoration: none;
}

.demo-icons header {
  text-align: center;
  padding: 100px 0 0;
}

.demo-icons header h1 {
  font-size: 2.8rem;
}

.demo-icons header p {
  font-size: 1.4rem;
  margin-top: 1em;
}

.demo-icons header a:hover {
  text-decoration: underline;
}

.demo-icons .nc-icon {
  font-size: 34px;
}

.demo-icons section h2 {
  border-bottom: 1px solid #e2e2e2;
  padding: 0 0 1em 0.2em;
  margin-bottom: 1em;
}

.demo-icons ul {
  padding-left: 0;
}

.demo-icons ul::after {
  clear: both;
  content: "";
  display: table;
}

.demo-icons ul li {
  width: 20%;
  float: left;
  padding: 16px 0;
  text-align: center;
  border-radius: 0.25em;
  transition: background 0.2s;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
}

.demo-icons ul li:hover {
  background: #f4f4f4;
}

.demo-icons ul p,
.demo-icons ul em,
.demo-icons ul input {
  display: inline-block;
  font-size: 1rem;
  color: #999999;
  -webkit-user-select: auto;
  user-select: auto;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.demo-icons ul p {
  padding: 20px 0 0;
  font-size: 12px;
  margin: 0;
}

.demo-icons ul p::selection,
.demo-icons ul em::selection {
  background: #608cee;
  color: #efefef;
}

.demo-icons ul em {
  font-size: 12px;
}

.demo-icons ul em::before {
  content: "[";
}

.demo-icons ul em::after {
  content: "]";
}

.demo-icons ul input {
  text-align: center;
  background: transparent;
  border: none;
  box-shadow: none;
  outline: none;
  display: none;
}

table {
  width: 100%;
  /* border: 1px solid lightgray; */
}

thead {
  color: #ffffff;
}

th {
  padding: 15px;
}

td {
  padding: 0 15px;
}

tfoot {
  color: gray;
}

tfoot th {
  font-weight: normal;
}

:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot .ant-steps-item-tail::after,
:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {
  width: 100%;
  height: 8px;
  margin-inline-start: 0;
  color: 'primary';
}

:where(.css-dev-only-do-not-override-1okl62o).ant-steps .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,
:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,
:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after,
.ant-steps-icon-dot {
  display: none;
}

:where(.css-dev-only-do-not-override-1okl62o).ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
  background-color: #BAF151;
  transition-delay: 0.2s;
  transition-duration: 0.4s;
}`, "",{"version":3,"sources":["webpack://./src/assets/demo/demo.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;CAiBC;AACD;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EAGrB,2BAA2B;EAC3B,yBAAyB;EAGzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,yBAAyB;EAGzB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":["/*!\n\n=========================================================\n* Paper Dashboard React - v1.3.2\n=========================================================\n\n* Product Page: https://www.creative-tim.com/product/paper-dashboard-react\n* Copyright 2023 Creative Tim (https://www.creative-tim.com)\n\n* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)\n\n* Coded by Creative Tim\n\n=========================================================\n\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n*/\n.tim-row {\n  margin-bottom: 20px;\n}\n\n.tim-white-buttons {\n  background-color: #777777;\n}\n\n.typography-line {\n  padding-left: 25%;\n  margin-bottom: 35px;\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.typography-line span {\n  bottom: 10px;\n  color: #c0c1c2;\n  display: block;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  left: 0;\n  position: absolute;\n  width: 260px;\n  text-transform: none;\n}\n\n.tim-row {\n  padding-top: 60px;\n}\n\n.tim-row h3 {\n  margin-top: 0;\n}\n\n.offline-doc .page-header {\n  display: flex;\n  align-items: center;\n}\n\n.offline-doc .footer {\n  position: absolute;\n  width: 100%;\n  background: transparent;\n  bottom: 0;\n  color: #fff;\n  z-index: 1;\n}\n\n@media all and (min-width: 992px) {\n  .sidebar .nav>li.active-pro {\n    position: absolute;\n    width: 100%;\n    bottom: 10px;\n  }\n}\n\n.card.card-upgrade .card-category {\n  max-width: 530px;\n  margin: 0 auto;\n}\n\n/* Nucleo Style */\n\n.demo-iconshtml {\n  font-size: 62.5%;\n}\n\n.demo-icons body {\n  font-size: 1.6rem;\n  font-family: sans-serif;\n  color: #333333;\n  background: white;\n}\n\n.demo-icons a {\n  color: #608cee;\n  text-decoration: none;\n}\n\n.demo-icons header {\n  text-align: center;\n  padding: 100px 0 0;\n}\n\n.demo-icons header h1 {\n  font-size: 2.8rem;\n}\n\n.demo-icons header p {\n  font-size: 1.4rem;\n  margin-top: 1em;\n}\n\n.demo-icons header a:hover {\n  text-decoration: underline;\n}\n\n.demo-icons .nc-icon {\n  font-size: 34px;\n}\n\n.demo-icons section h2 {\n  border-bottom: 1px solid #e2e2e2;\n  padding: 0 0 1em 0.2em;\n  margin-bottom: 1em;\n}\n\n.demo-icons ul {\n  padding-left: 0;\n}\n\n.demo-icons ul::after {\n  clear: both;\n  content: \"\";\n  display: table;\n}\n\n.demo-icons ul li {\n  width: 20%;\n  float: left;\n  padding: 16px 0;\n  text-align: center;\n  border-radius: 0.25em;\n  -webkit-transition: background 0.2s;\n  -moz-transition: background 0.2s;\n  transition: background 0.2s;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  overflow: hidden;\n}\n\n.demo-icons ul li:hover {\n  background: #f4f4f4;\n}\n\n.demo-icons ul p,\n.demo-icons ul em,\n.demo-icons ul input {\n  display: inline-block;\n  font-size: 1rem;\n  color: #999999;\n  -webkit-user-select: auto;\n  -moz-user-select: auto;\n  -ms-user-select: auto;\n  user-select: auto;\n  white-space: nowrap;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.demo-icons ul p {\n  padding: 20px 0 0;\n  font-size: 12px;\n  margin: 0;\n}\n\n.demo-icons ul p::selection,\n.demo-icons ul em::selection {\n  background: #608cee;\n  color: #efefef;\n}\n\n.demo-icons ul em {\n  font-size: 12px;\n}\n\n.demo-icons ul em::before {\n  content: \"[\";\n}\n\n.demo-icons ul em::after {\n  content: \"]\";\n}\n\n.demo-icons ul input {\n  text-align: center;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  outline: none;\n  display: none;\n}\n\ntable {\n  width: 100%;\n  /* border: 1px solid lightgray; */\n}\n\nthead {\n  color: #ffffff;\n}\n\nth {\n  padding: 15px;\n}\n\ntd {\n  padding: 0 15px;\n}\n\ntfoot {\n  color: gray;\n}\n\ntfoot th {\n  font-weight: normal;\n}\n\n:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot .ant-steps-item-tail::after,\n:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot.ant-steps-small .ant-steps-item-tail::after {\n  width: 100%;\n  height: 8px;\n  margin-inline-start: 0;\n  color: 'primary';\n}\n\n:where(.css-dev-only-do-not-override-1okl62o).ant-steps .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot,\n:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot .ant-steps-item-icon .ant-steps-icon-dot::after,\n:where(.css-dev-only-do-not-override-1okl62o).ant-steps.ant-steps-dot.ant-steps-small .ant-steps-item-icon .ant-steps-icon-dot::after,\n.ant-steps-icon-dot {\n  display: none;\n}\n\n:where(.css-dev-only-do-not-override-1okl62o).ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {\n  background-color: #BAF151;\n  transition-delay: 0.2s;\n  transition-duration: 0.4s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
